import React from 'react';
import type { ListProps } from '@mui/material';
import { List as MuiList } from '@mui/material';

const List: React.FC<ListProps> = (props) => {
  return <MuiList {...props}>{props.children}</MuiList>;
};

export default List;
